var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsuranceDirectChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 325,
    viewBox: "0 0 325 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 162.5,
    r: 162.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 0C191.52 3.46065e-07 220.011 7.77161 245.012 22.5073C270.013 37.2429 290.612 58.4049 304.668 83.7943C318.724 109.184 325.724 137.874 324.941 166.884C324.158 195.894 315.621 224.165 300.216 248.759C284.811 273.353 263.101 293.373 237.342 306.739C211.582 320.105 182.714 326.329 153.736 324.763C124.757 323.198 96.727 313.901 72.5573 297.839C48.3875 281.776 28.9602 259.534 16.2942 233.423L162.5 162.5V0Z",
    fill: "#7033FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceDirectChart);
export default __webpack_public_path__ + "static/media/insurance-direct-chart.51be0982a4723fadf1ad0fa341e9ede4.svg";
export { ForwardRef as ReactComponent };